import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    zIndex: 100,
    background: theme.palette.background.paper,
    position: 'absolute',
    width: '100%',
    minHeight: '100%',
    top: 0,
    left: 0,
    overflowY: 'auto',
    boxSizing: 'border-box'
  }
}));
